var map = {
	"./00001Dr. Narinder Singh Kapoor.jpg": 5208,
	"./00002 Dr. Dalip Kaur Tiwana .png": 4334,
	"./00003Jasbir Bhullar.png": 9387,
	"./004Ram Saroop Anakhi ਰਾਮ ਸਰੂਪ ਅਣਖੀ.png": 6421,
	"./006osho.png": 4416,
	"./010Bachint Kaur.png": 530,
	"./015Dr. Mandeep Gaur.png": 7938,
	"./016Nanak Singh.png": 7836,
	"./020Dr. Gurcharan Kaur Kocher.png": 2335,
	"./021Surjit Patar.png": 645,
	"./022Dr. Harshinder Kaur M.D.png": 2223,
	"./023Kulbir Singh Suri.png": 4771,
	"./03Variam singh Sandhu.png": 9230,
	"./06Jeet Singh Sandhu.png": 6695,
	"./07Karam Jeet Singh Aujala ਕਰਮ ਜੀਤ ਸਿੰਘ ਔਜਲਾ.png": 9341,
	"./08Jasvir Singh Rana.png": 5897,
	"./09Mittar Sain Meet.png": 1895,
	"./1 Baldev Singh .jpg": 1453,
	"./11Gurbaksh S Bhandaal.png": 5642,
	"./1Amrita Pritam.png": 4063,
	"./Aashiq husain Chaudhary.png": 1491,
	"./Ajaib SIngh Sandhu.png": 9988,
	"./Ajeet Kaur.png": 5873,
	"./Ajeet Raahi.png": 3771,
	"./Ajmer Sidhu.png": 6061,
	"./Amarjit Kaur Naaz.png": 9486,
	"./Amarjit Kaur Pannu.png": 3348,
	"./Amarpreet Singh Jheeta.png": 4236,
	"./Ameen Malik.png": 3511,
	"./Amia Kunwar.png": 3831,
	"./Amrik Singh Sher Khan.png": 1108,
	"./Anupam Kher.png": 6119,
	"./Anuradha Beniwal.png": 6785,
	"./Balbir Kaur Sangherha.png": 7953,
	"./Balbir Madhopuri.png": 2364,
	"./Balbir Parvana.png": 4890,
	"./Baldev Singh Dhaliwal.png": 1976,
	"./Balraj Kohara.png": 9323,
	"./Balwant Gargi.png": 3262,
	"./Balwant Singh ' Musafir '.png": 7314,
	"./Bhagat Puran Singh.png": 9985,
	"./Bhagat Singh.png": 4213,
	"./Bharga Nand.png": 3667,
	"./Bhola Singh Sangherha ਭੋਲਾ ਸਿੰਘ ਸੰਘੇੜਾ.png": 4447,
	"./Bhupinder Singh Saggu.png": 7062,
	"./Bhupinder Ustad.png": 5197,
	"./Bikramjeet Singh Noor.png": 7742,
	"./Commodore Gurnam Singh.png": 7899,
	"./Darshan Bulandvi.png": 7519,
	"./Deep Davinder Singh.png": 6011,
	"./Deep Devinder Singh ਦੀਪ ਦੇਵਿੰਦਰ ਸਿੰਘ​.png": 3312,
	"./Des Raaj Kali.png": 1000,
	"./Devinder Kaur Saini.png": 3639,
	"./Devinder Singh Bibipuria.png": 3026,
	"./Dr. Ajaib Singh.png": 755,
	"./Dr. Amanpreet Singh.png": 1297,
	"./Dr. Amarjeet Singh Gorki.png": 7407,
	"./Dr. Amrik Singh Kanda.png": 6579,
	"./Dr. Balwinder singh.png": 482,
	"./Dr. Bishavroop.png": 1352,
	"./Dr. Biswaroop Roy Chowdhury.png": 9504,
	"./Dr. Gurbhajan Singh Gill.png": 3570,
	"./Dr. Hardeep Singh.png": 5155,
	"./Dr. Harpal Singh Pannu.png": 3206,
	"./Dr. Inderjeet Kaur.png": 9983,
	"./Dr. Joseph Murphy.png": 8225,
	"./Dr. Lakhwinder Jauhal.png": 8505,
	"./Dr. Naib Singh Mander.png": 73,
	"./Dr. Pardeep Kaura ਡਾ. ਪ੍ਰਦੀਪ ਕੌੜਾ.jpg": 2695,
	"./Dr. Parmod Shankar Soni.png": 9221,
	"./Dr. Rajinder Singh.png": 303,
	"./Dr. Ranjeet Singh.png": 9339,
	"./Dr. Sardara Singh Johal.png": 3420,
	"./Dr. Shyam Sunder Deepti.png": 9653,
	"./Dr. T.R. Sharma.png": 2175,
	"./Dr. Vijay Agarwal.png": 353,
	"./Dr. arshdeep singh.png": 9978,
	"./Dr.Amanpreet Singh.png": 4913,
	"./Dr.Pushpinder singh.png": 7834,
	"./Emile Zola.png": 6037,
	"./Ernest Hemingway.png": 5483,
	"./Farazand Ali.png": 3850,
	"./Farkhanda Lodhi.png": 9697,
	"./Franz Kafka.png": 5256,
	"./Giani Tarlok Singh.png": 8723,
	"./Gulzaar Singh Sandhu.png": 8631,
	"./Gurbachan Singh Bhullar.png": 3747,
	"./Gurbachan Singh Laadpuri.png": 4609,
	"./Gurbaksh Singh Bhandaal.png": 9008,
	"./Gurbaksh Singh.png": 8341,
	"./Gurcharan Singh Jaiton.png": 580,
	"./Gurdayal Singh.png": 1104,
	"./Gurdeep Kaur.png": 770,
	"./Gurdev Singh Sandhu.png": 5916,
	"./Gurdev singh rupana.png": 2518,
	"./Gurmail Madahar.png": 9560,
	"./Gurnaam Singh Seetal.png": 5571,
	"./Gurpreet Singh Toor.png": 224,
	"./Guru Nanak Dev Ji.png": 6563,
	"./Hardev Singh Grewal.png": 220,
	"./Harinder Singh Mehboob.png": 3805,
	"./Harjeet Singh Gill.png": 2093,
	"./Harjinder Soorewalia.png": 6740,
	"./Harjit Kaur Virk_ਹਰਜੀਤ ਕੌਰ ਵਿਰਕ.png": 5804,
	"./Harman .png": 9398,
	"./Harpinder Rana.png": 8270,
	"./Harpreet Singh Channu.png": 4072,
	"./Imroz.png": 1924,
	"./InderjitPal Kaur.png": 2356,
	"./Jagdev Singh Sandhu.png": 8108,
	"./Jagdish Kaur Maan.png": 2589,
	"./Jaspreet Kaur Falak.png": 7301,
	"./Jaspreet Mangat.png": 2357,
	"./Jaswant Singh Aman.png": 9369,
	"./Jaswant Singh Kanwal.png": 7368,
	"./Jeevan singh.png": 7907,
	"./Jinder .png": 9031,
	"./Jinder Khalid Farhaad Dhariwal.png": 8745,
	"./Jyoti Bawa.png": 7813,
	"./K.L Garg.png": 4237,
	"./Kahlil Gibran.png": 9207,
	"./Kamalpreet Sanghera.png": 5202,
	"./Kamleshwar.png": 8714,
	"./Karam Singh Zakhmi.png": 1862,
	"./Karamjeet Singh Aujla.png": 9025,
	"./Karanjeet Singh Komal.png": 2591,
	"./Khushveen Kaur Baath.png": 5933,
	"./Krishan Chander.png": 9218,
	"./Krishan Partap.png": 5031,
	"./Krishna Sobti.png": 1508,
	"./Kudsiya Huma.png": 1710,
	"./Kulbir Badesron.png": 0,
	"./Kuldeep Kaur Bhullar.png": 3950,
	"./Kuldeep bagga.png": 8483,
	"./Kulwant Jagraon.png": 4535,
	"./Kulwant Singh Virk.png": 7254,
	"./Lal Singh Kalsi.png": 1607,
	"./Malkit Singh Ghuman.png": 1294,
	"./Mandeep Kaur Bhamra.png": 1929,
	"./Manga Singh Antal.png": 5124,
	"./Manjit singh Boparai.png": 5205,
	"./Manmohan Singh Daun.png": 5497,
	"./Mansha yaad.png": 2328,
	"./Maxim Gorky.png": 6823,
	"./Minakshi Chaudhary.png": 6474,
	"./Mukhtar gill.png": 4939,
	"./Mumtaz Husain.png": 9199,
	"./Munshi Prem chand.png": 5017,
	"./Narinjan Tasneem.png": 5731,
	"./Navtej Puadhi.png": 8468,
	"./Ninder Ghugianvi.png": 4671,
	"./Nirmal Jora.png": 712,
	"./Nirmal Singh Thali.png": 467,
	"./Nirmal nimma langah.png": 6867,
	"./Nirmaljit Kaur Ghumman.png": 595,
	"./Parambir Kaur.png": 5176,
	"./Paramjit Kaur Nijjar.png": 5450,
	"./Parmesher Singh Berkalaan.png": 8800,
	"./Parminder Sodhi.png": 9236,
	"./Paulo Coelho.png": 7030,
	"./Pr. Sujan Singh.png": 9151,
	"./Principal Ganga Singh.png": 6904,
	"./Principal Sarwan Singh.png": 2638,
	"./Prof. Puran Singh.png": 885,
	"./Raaju Bharatan.png": 4727,
	"./Rabindranath Tagore.png": 8509,
	"./Rachhpal Kaur Gill.png": 5941,
	"./Raj Lalli Batala.png": 8851,
	"./Raja Ram Handiaya.png": 3352,
	"./Rakesh Shankar Bharti .png": 5709,
	"./Rakesh raman.png": 9084,
	"./Ram Lal Premi.png": 4273,
	"./Ram Saroop Sharma.png": 613,
	"./Raminder Rami.png": 2556,
	"./Ranjodh Singh.png": 1366,
	"./Rasul Gamzatov.png": 997,
	"./Renuka Sarabjit Singh.png": 9052,
	"./Rhonda Byrne.png": 1795,
	"./Rohim Saini.png": 3744,
	"./Roop Dhillon.png": 3441,
	"./Rovert T. Kiyosaki.png": 9633,
	"./S. Saki.png": 9582,
	"./S. Tarsem.png": 5864,
	"./S.S. Wanjara.png": 2873,
	"./Saleem Khan Gimmi.png": 4017,
	"./Sant Singh Sekhon.png": 3098,
	"./Sardar Panchhi.png": 5597,
	"./Satnam Singh Salopuri.png": 3203,
	"./Shakespeare.png": 45,
	"./Sharat Chandar Chattopadhyay.png": 2742,
	"./Shiv Charan Jaggi Kussa.png": 5579,
	"./Simipreet Kaur.png": 9812,
	"./Simran Dhaliwal.png": 3439,
	"./Sir Arther Canon Dial.png": 4912,
	"./Sohan Singh Seetal.png": 5795,
	"./Sukhdev Singh Laaj.png": 3423,
	"./Sukhmandar Singh Sitara.png": 2743,
	"./Sukhwinder Amrit.png": 8746,
	"./Surinder Geet.png": 6328,
	"./Surinder Singh Narula.png": 8359,
	"./Surjeet Singh Sajan.png": 4738,
	"./Surjeet.png": 3937,
	"./Trilochan lochi.png": 1856,
	"./Uma Trilok.png": 4857,
	"./Veena Verma .jpg": 2949,
	"./Vladimir Bogomolov.png": 1451,
	"./Zubair Ahemed.png": 614,
	"./gurbaksh singh preetlari.png": 5199,
	"./Émile Zola.png": 6441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 772;